/* https://polaris.shopify.com/components/structure/app-provider#section-using-linkcomponent */

import React from 'react';
import { AppProviderProps } from '@shopify/polaris';
import { Link as ReactRouterLink } from 'react-router-dom';

type LinkLikeComponent = AppProviderProps['linkComponent'];

const IS_EXTERNAL_LINK_REGEX = /^(?:[a-z][a-z\d+.-]*:|\/\/)/;

const Link: LinkLikeComponent = ({ ref, children, url = '', external, ...rest }) => {
  /**
   * react-router only supports links to pages it can handle itself. It does not
   * support arbitrary links, so anything that is not a path-based link should
   * use a regular old `a` tag
   */

  if (external || IS_EXTERNAL_LINK_REGEX.test(url)) {
    return (
      <a href={url} ref={ref} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  return (
    // NOTE: refs in polaris and router are incompatible, if really needed, implement ref manually
    <ReactRouterLink to={url} {...rest} /* ref={ref as Ref<HTMLAnchorElement>} */>
      {children}
    </ReactRouterLink>
  );
};

export default Link!;
